// extracted by mini-css-extract-plugin
export default {"c1Box":"C1_c1Box__wb3u+","shrinked":"C1_shrinked__NlM-k","backGradient":"C1_backGradient__wpm45","textBox":"C1_textBox__lz049"};